import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from "../../store";
import { RouteConstants,DASHBOARD_TABS } from '../../constants/constants';
import EmptyDashboard from '../../pages/dashboard/EmptyDashboard'
import { getOnBoardingAPIData, getOnBoardingAPIStatus } from '../../slices/onBoardingSlice';
import SummaryStatistics from '../SummaryStatistics/SummaryStatistics';
import { setActiveDashboardTab } from "../../slices/userProfileSlice";
import { USER_ROLE } from '../../constants/constants';
import useWindowSize from 'src/utils/useWindowSize';
import { getUserInfo } from '../../slices/userProfileSlice';

const CheckUser = () => {
  const { height } = useWindowSize();
  const [showSummaryStatistics, setShowSummaryStatistics] = useState(false)
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userOnboardAPIStatus = useSelector(getOnBoardingAPIStatus);
  const userOnboardStatus = useSelector(getOnBoardingAPIData);
  const { eid } = useSelector(getUserInfo);

  useEffect(() => {
    if (userOnboardAPIStatus === 'finished' && userOnboardStatus) {
      if (userOnboardStatus.user_onboard_status === 'on-boarded') {
        if (userOnboardStatus.roles && userOnboardStatus.roles.length && (userOnboardStatus.roles[0] === USER_ROLE.MODEL_POWER_USER )) { 
          // dispatch(setActiveDashboardTab(DASHBOARD_TABS.));
          navigate(RouteConstants.LANDING_PAGE);
        }

        if (userOnboardStatus.roles && userOnboardStatus.roles.length && (userOnboardStatus.roles[0] === USER_ROLE.POWER_USER || userOnboardStatus.roles[0] === USER_ROLE.LEADERSHIP_USER|| userOnboardStatus.roles[0] === USER_ROLE.DOMAIN_FOCAL||userOnboardStatus.roles[0] === USER_ROLE.DOMAIN_FOCAL)) { 
          dispatch(setActiveDashboardTab(DASHBOARD_TABS.OVERVIEW));
          navigate(RouteConstants.LANDING_PAGE);
        }
        else  navigate(RouteConstants.LANDING_PAGE);

      } else if (userOnboardStatus.user_onboard_status === 'eligible') {
        navigate(RouteConstants.ONBOARDING);
      } else if (userOnboardStatus.user_onboard_status === 'not-eligible') {
        navigate(RouteConstants.FORBIDDEN);
      } else {
        navigate(RouteConstants.PAGE_NOT_FOUND);
      }
    } else if (userOnboardAPIStatus === 'error') {
      navigate(RouteConstants.PAGE_NOT_FOUND);
    }
  }, [userOnboardAPIStatus])

  if(userOnboardAPIStatus !== 'finished'){
    return <EmptyDashboard />
  }

  let minContentHeight = `${window.innerHeight - 195}px`; 
  return (
    <div> {!showSummaryStatistics ? <EmptyDashboard /> :
      <div style={{ "minHeight": `${minContentHeight}` }}> 
        <SummaryStatistics isLandingPage={true} hideSummaryStatistics={() => { }} />
      </div>
    }
    </div>
  )
};

export default CheckUser;